(() => {
  if (window.i293) return

  let qty = 1

  function config() {
    const el = document.getElementById("i293-bundle")
    if (!el) return null
    return JSON.parse(el.textContent)
  }

  function money(cents, currency) {
    return new Intl.NumberFormat(document.documentElement.lang || "en-US", { style: "currency", currency: currency || "USD" }).format(cents / 100)
  }

  function planValue(select) {
    return select.value ?? select.getAttribute("value") ?? select.querySelector("option")?.value
  }

  function selectedPlan() {
    const select = document.querySelector("[data-i293-subscribe] [data-i293-plan]")
    const id = select && planValue(select)
    const plan = id && config()?.plans?.[id]
    if (!plan) return null
    return { a: Number(id), b: Number(plan.b), price: plan.price ?? null, label: plan.label }
  }

  function subscription() {
    const toggle = document.querySelector("[data-i293-subscribe] [data-i293-subscribe-toggle]")
    return toggle?.checked ? selectedPlan() : null
  }

  function prices() {
    const cfg = config()
    if (!cfg) return
    const full = cfg.items.reduce((sum, item) => sum + (item.full || item.price), 0) * qty
    const perBundle = Math.round(cfg.items.reduce((sum, item) => sum + item.price, 0) * (100 - cfg.discount) / 100)
    const sale = perBundle * qty
    const planPrice = selectedPlan()?.price
    const subscribe = planPrice != null ? Math.round(planPrice * (100 - cfg.discount) / 100) : Math.round(perBundle * (100 - (cfg.subscribeDiscount || 0)) / 100)
    const pay = subscription() ? subscribe * qty : sale
    const renew = planPrice ?? subscribe
    const values = { full: money(full, cfg.currency), sale: money(sale, cfg.currency), save: money(full - sale, cfg.currency), subscribe: money(subscribe, cfg.currency), renew: money(renew, cfg.currency), pay: money(pay, cfg.currency) }
    for (const el of document.querySelectorAll("[data-i293-price]")) {
      el.textContent = values[el.dataset.i293Price]
    }
    for (const el of document.querySelectorAll("[data-i293-qty-value]")) {
      el.textContent = qty
    }
    window.setPrice?.(pay, full > pay ? full : null)
  }

  function setQty(next) {
    qty = Math.max(1, Math.min(10, next))
    prices()
  }

  async function post(url, body) {
    const res = await fetch(url, {
      method: "POST",
      headers: { "content-type": "application/json", accept: "application/json", "x-requested-with": "XMLHttpRequest" },
      body: JSON.stringify(body)
    })
    const data = await res.json()
    if (!res.ok) throw new Error(data.description || data.message || `${url} failed: ${res.status}`)
    return data
  }

  async function applyCode(code) {
    const res = await fetch(`${window.routes?.cart_url || "/cart"}.js`, { headers: { accept: "application/json" } })
    if (!res.ok) throw new Error(`cart.js failed: ${res.status}`)
    const codes = (await res.json()).discount_codes.map(d => d.code)
    if (codes.some(c => c.toLowerCase() === code.toLowerCase())) return
    await post("/cart/update.js", { discount: codes.concat(code).join(",") })
  }

  async function openDrawer() {
    const drawer = document.querySelector("cart-drawer")
    if (!drawer?.renderContents) {
      location.href = window.routes?.cart_url || "/cart"
      return
    }
    const res = await fetch(`${window.routes?.root_url || "/"}?sections=cart-drawer,cart-icon-bubble`)
    if (!res.ok) throw new Error(`cart sections failed: ${res.status}`)
    drawer.renderContents({ sections: await res.json() })
  }

  async function addToCart(button) {
    const cfg = config()
    if (!cfg) throw new Error("i293: no bundle config on this page")
    const from = window.antePageId || "i293"
    const type = cfg.items.length > 1 ? "b" : "m"
    const plan = subscription()
    const items = cfg.items.map((item, i) => {
      const line = { id: item.id, quantity: qty, properties: { _data: `f:${from},t:${type}`, _bundle: cfg.bundle } }
      if (plan) line.selling_plan = i === 0 ? plan.a : plan.b
      return line
    })
    const buttons = Array.from(document.querySelectorAll(".i293 buy-button"))
    button.loading = true
    for (const other of buttons) if (other !== button) other.disabled = true
    try {
      await window.addToCart({ items })
      if (cfg.code) await applyCode(cfg.code)
      await openDrawer()
    } catch (e) {
      console.error("i293 add to cart:", e)
    } finally {
      button.loading = false
      for (const other of buttons) other.disabled = false
    }
  }

  function pad(n) {
    return String(Math.max(0, n)).padStart(2, "0")
  }

  function tick() {
    for (const el of document.querySelectorAll("[data-i293-countdown]")) {
      const ms = Math.max(0, new Date(el.dataset.i293Countdown).getTime() - Date.now())
      if (isNaN(ms)) continue
      const s = Math.floor(ms / 1000)
      const left = { days: Math.floor(s / 86400), hours: Math.floor((s % 86400) / 3600), minutes: Math.floor((s % 3600) / 60), seconds: s % 60 }
      for (const unit of el.querySelectorAll("[data-unit]")) {
        const value = pad(left[unit.dataset.unit])
        if (unit.textContent === value) continue
        if (unit.textContent) {
          unit.classList.remove("is-rolling")
          void unit.offsetWidth
          unit.classList.add("is-rolling")
        }
        unit.textContent = value
      }
      el.classList.toggle("is-done", ms <= 0)
    }
  }

  function toggleAccordion(button) {
    const item = button.closest("[data-i293-accordion]")
    const open = !item.classList.contains("is-open")
    if (open) {
      const group = item.closest("[data-i293-accordion-group]")
      for (const other of group ? group.querySelectorAll("[data-i293-accordion].is-open") : []) {
        if (other === item) continue
        other.classList.remove("is-open")
        other.querySelector(".i293-accordion-toggle")?.setAttribute("aria-expanded", "false")
      }
    }
    item.classList.toggle("is-open", open)
    button.setAttribute("aria-expanded", String(open))
  }

  const SPLIDE = "https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist"

  function mountGallery(gallery) {
    const main = new window.Splide(gallery.querySelector("[data-i293-slides]"), { rewind: true, arrows: false, pagination: false, flickPower: 75, flickMaxPages: 0.3, breakpoints: { 749: { padding: { right: "14%" }, gap: 12 } } })
    gallery.i293Main = main
    const thumbs = new window.Splide(gallery.querySelector("[data-i293-thumbs]"), { isNavigation: true, rewind: true, arrows: false, pagination: false, perPage: 6, gap: 16, flickPower: 75, flickMaxPages: 0.3, breakpoints: { 749: { perPage: 6, gap: 8 } } })
    main.sync(thumbs)
    main.on("move", index => gallery.classList.toggle("is-start", index === 0))
    main.mount()
    thumbs.mount()
    gallery.classList.add("is-ready")
  }

  function initGalleries() {
    const galleries = document.querySelectorAll("[data-i293-gallery]:not(.is-ready)")
    if (!galleries.length) return
    const css = `${SPLIDE}/css/splide-core.min.css`
    if (!document.querySelector(`link[href="${css}"]`)) {
      const link = document.createElement("link")
      link.rel = "stylesheet"
      link.href = css
      document.head.append(link)
    }
    loadLibrary(() => window.Splide, `${SPLIDE}/js/splide.min.js`).then(() => {
      for (const gallery of galleries) mountGallery(gallery)
    }).catch(e => console.error("i293 gallery:", e))
  }

  function expand(button) {
    const wrap = button.closest(".wall-wrap")
    if (!wrap || wrap.classList.contains("is-expanding")) return
    wrap.style.maxHeight = wrap.offsetHeight + "px"
    void wrap.offsetHeight
    wrap.classList.add("is-expanding")
    wrap.style.maxHeight = wrap.scrollHeight + "px"
    function done() {
      wrap.removeEventListener("transitionend", onEnd)
      wrap.classList.add("is-expanded")
      wrap.style.maxHeight = ""
    }
    function onEnd(e) {
      if (e.target === wrap && e.propertyName === "max-height") done()
    }
    wrap.addEventListener("transitionend", onEnd)
    setTimeout(() => {
      if (!wrap.classList.contains("is-expanded")) done()
    }, 1600)
  }

  function loadLibrary(test, src, css) {
    if (test()) return Promise.resolve()
    if (css && !document.querySelector(`link[href="${css}"]`)) {
      const link = document.createElement("link")
      link.rel = "stylesheet"
      link.href = css
      document.head.append(link)
    }
    return new Promise((resolve, reject) => {
      const script = document.createElement("script")
      script.src = src
      script.onload = resolve
      script.onerror = () => reject(new Error(`Failed to load ${src}`))
      document.head.append(script)
    })
  }

  function libraries() {
    if (document.querySelector(".i293 [data-popupable]")) {
      loadLibrary(() => window.popupableAnimTypes, "https://cdn.jsdelivr.net/npm/popupable@1.11.0/dist/popupable.min.js", "https://cdn.jsdelivr.net/npm/popupable@1.11.0/dist/popupable.min.css").catch(e => console.error("i293:", e))
    }
    initGalleries()
  }

  function initReveal() {
    const items = document.querySelectorAll(".i293-reveal:not(.is-visible)")
    if (!("IntersectionObserver" in window)) {
      for (const item of items) item.classList.add("is-visible")
      return
    }
    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue
        entry.target.classList.add("is-visible")
        observer.unobserve(entry.target)
      }
    }, { rootMargin: "0px 0px -10% 0px" })
    for (const item of items) observer.observe(item)
  }

  document.addEventListener("click", e => {
    const add = e.target.closest(".i293 buy-button")
    if (add) {
      e.preventDefault()
      addToCart(add)
      return
    }
    const step = e.target.closest("[data-i293-qty]")
    if (step) {
      setQty(qty + Number(step.dataset.i293Qty))
      return
    }
    const go = e.target.closest("[data-i293-gallery-go]")
    if (go) {
      go.closest("[data-i293-gallery]").i293Main?.go(go.dataset.i293GalleryGo)
      return
    }
    const facts = e.target.closest("[data-i293-facts]")
    const factsModal = facts && document.querySelector(".i293 .facts-modal")
    if (factsModal) {
      e.preventDefault()
      factsModal.showModal()
      return
    }
    const open = e.target.closest("[data-i293-dialog]")
    if (open) {
      document.getElementById(open.dataset.i293Dialog)?.showModal()
      return
    }
    const dialog = e.target.closest("dialog")
    if (dialog && (e.target === dialog || e.target.closest("[data-i293-dialog-close]"))) {
      dialog.close()
      return
    }
    const more = e.target.closest("[data-i293-expand]")
    if (more) {
      expand(more)
      return
    }
    const accordion = e.target.closest(".i293-accordion-toggle")
    if (accordion) toggleAccordion(accordion)
  })

  function syncSubscribe(box) {
    const plan = selectedPlan()
    box.classList.toggle("is-on", box.querySelector("[data-i293-subscribe-toggle]").checked)
    const label = box.querySelector("[data-i293-plan-label]")
    if (label && plan) label.textContent = plan.label
  }

  document.addEventListener("change", e => {
    const box = e.target.closest("[data-i293-subscribe]")
    if (!box) return
    if (e.target.matches("[data-i293-plan]")) box.querySelector("[data-i293-subscribe-toggle]").checked = true
    syncSubscribe(box)
    prices()
  })

  window.i293 = { config, prices, tick }

  function start() {
    for (const box of document.querySelectorAll("[data-i293-subscribe]")) syncSubscribe(box)
    prices()
    tick()
    initReveal()
    libraries()
    setInterval(tick, 1000)
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start)
  } else {
    start()
  }

  document.addEventListener("shopify:section:load", () => {
    prices()
    tick()
    initReveal()
    libraries()
  })
})()
